import { useQuery } from "@tanstack/react-query";
import { LoaderFunction } from "react-router-dom";

import { PAYMENT_DETAILS_KEY } from "@/client/constants/query-keys";
import { axios } from "@/client/libs/axios";
import { queryClientPayment } from "@/client/libs/query-client";
import { usePaymentStore } from "@/client/stores/payment";

export const getPaymentDetails = async () => {
  const response = await axios.get(`/payment/details`);
  //---
  return response.data;
};

export const usePayment = () => {
  const {
    error,
    isPending: loading,
    data: payment,
  } = useQuery({
    queryKey: PAYMENT_DETAILS_KEY,
    queryFn: () => getPaymentDetails(),
  });
  //---
  return { payment, loading, error };
};

export const paymentLoader: LoaderFunction = async () => {
  try {
    const payment = await queryClientPayment.fetchQuery({
      queryKey: PAYMENT_DETAILS_KEY,
      queryFn: () => getPaymentDetails(),
    });
    usePaymentStore.setState({ payment: payment });
    //---
    return payment;
  } catch (error) {
    usePaymentStore.setState({
      payment: {
        isPaid: false,
        downloadCount: 0,
      },
    });
    //---
    return null;
  }
};

export const updatePaymentInfo = async () => {
  try {
    const payment = await queryClientPayment.fetchQuery({
      queryKey: PAYMENT_DETAILS_KEY,
      queryFn: () => getPaymentDetails(),
    });
    return payment;
  } catch (error) {
    return { isPaid: false, downloadCount: 0 };
  }
};
